import {PortExposureBodyChunk} from "../chunks/types/PortExposureBodyChunk";
import {childPortChunkToChildPortRef} from "./childPortChunkToChildPortRef";
import {ChildPortRef} from "./types/ChildPortRef";

export function portExposureBodyChunkToChildPortRef(
  portExposureBodyChunk: PortExposureBodyChunk
): ChildPortRef<any, any> {
  const {
    captures: {
      1: childPortChunk
    }
  } = portExposureBodyChunk;
  return childPortChunkToChildPortRef(childPortChunk);
}
